import { useQuery } from "react-query"
import { get_job_seeker_interested_positions } from "../../../services/approvals";


const UseJobSeekerInterestedPositions = (id) => {
    return useQuery('get_job_seeker_interested_positions', ()=> get_job_seeker_interested_positions(id))
}

export default UseJobSeekerInterestedPositions;